<button class="action-btn" *ngIf="buttonText" (click)="onActionButtonClick()">
  <span class="action-btn-label">{{ buttonText }}</span>
</button>
